import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CreateShipmentRequest } from 'app/generated/backend/shipment/api/create-shipment-request';
import { CreateShipmentResponse } from 'app/generated/backend/shipment/api/create-shipment-response';

@Injectable()
export class CreateShipmentHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		request: CreateShipmentRequest
	): Observable<JsonResourceResponse<CreateShipmentResponse>> {
		return this.http.post<JsonResourceResponse<CreateShipmentResponse>>('api/v1/shipment/shipments/createShipment', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		CreateShipmentHandlerService
	]
})
export class CreateShipmentHandlerModule { }
